import { ShippingMethodTypes } from "@features/checkout/types";
import { useStore } from "@store/store";
import type { StoreData } from "@features/stores/types";

export const usePickupStoreSelection = (
    shippingMethodKey?: ShippingMethodTypes
): ((store: StoreData) => void) => {
    const setStoreData = useStore((state) => state.setStoreData);
    const setParcelShopData = useStore((state) => state.setParcelShopData);

    return shippingMethodKey === ShippingMethodTypes.PARCEL_SHOP ? setParcelShopData : setStoreData;
};
